import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from '@tiptap/extension-list-item';
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { useMemo } from 'react';
import { createNodeAdapter } from '../../node';
export function createListItemBlockNode(config) {
    const { Component, blockContext: { Provider: BlockContextProvider }, } = config;
    const TiptapComponent = (props) => {
        const adapter = useMemo(() => createNodeAdapter(props), [props]);
        const viewProps = {
            id: props.node.attrs.tiptapNodeId ?? null,
            adapter,
        };
        return (_jsx(NodeViewWrapper, { "data-block-id": props.node.attrs.blockId, "data-tiptap-node-id": props.node.attrs.tiptapNodeId, children: _jsx(BlockContextProvider, { value: { adapter }, children: _jsx(Component, { ...viewProps, children: _jsx(NodeViewContent, {}) }) }) }));
    };
    return ListItem.extend({
        name: 'listItem',
        addAttributes() {
            return {
                ...this.parent?.(),
                blockId: {
                    default: null,
                    parseHTML: (element) => element.getAttribute('data-block-id'),
                    renderHTML: (attributes) => {
                        if (!attributes.blockId) {
                            return {};
                        }
                        return { 'data-block-id': attributes.blockId };
                    },
                },
            };
        },
        addNodeView() {
            return ReactNodeViewRenderer(TiptapComponent);
        },
        addKeyboardShortcuts() {
            const parentShortcuts = this.parent?.() || {};
            const enterKey = 'Enter'; // For type safety
            return {
                ...parentShortcuts,
                [enterKey]: () => {
                    const editor = this.editor;
                    const { state } = editor;
                    const { selection } = state;
                    const { $from, empty } = selection;
                    if (empty &&
                        $from.parent.isTextblock &&
                        $from.parent.content.size === 0) {
                        const textBlockType = editor.schema.nodes.textBlock;
                        if (!textBlockType) {
                            console.error('[listItem] textBlock type not found in schema! Falling back to default lift.');
                            return parentShortcuts[enterKey]
                                ? parentShortcuts[enterKey]({ editor })
                                : false;
                        }
                        return editor
                            .chain()
                            .liftListItem(this.name)
                            .setNode(textBlockType)
                            .focus()
                            .run();
                    }
                    return parentShortcuts[enterKey]
                        ? parentShortcuts[enterKey]({ editor })
                        : false;
                },
            };
        },
    });
}
//# sourceMappingURL=listItemBlockExtension.js.map